import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../styles/OfficeProcedures.css";

export default function YTOfficeProcedures({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const [expandedAccordion, setExpandedAccordion] = useState(false);

  // Add CSS for accordion content
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .accordion-content ol {
        margin-left: -15px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    setProvince("YT");
  });

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);

    // Scroll to the top of the first accordion when expanded (mobile only)
    if (isExpanded && window.innerWidth <= 768) {
      console.log(
        "Accordion clicked, panel:",
        panel,
        "isExpanded:",
        isExpanded
      );

      // Use a longer timeout for iOS and add multiple attempts
      const scrollToFirstAccordion = () => {
        // Try multiple selectors to find the first accordion
        const firstAccordion =
          document.querySelector('[data-testid="accordion-0"]') ||
          document.querySelector(".MuiAccordion-root") ||
          document.querySelector('[role="region"]');
        console.log("Found first accordion:", firstAccordion);

        if (firstAccordion) {
          console.log("Attempting to scroll to first accordion");
          try {
            // Get the position and add offset to position just below header
            const rect = firstAccordion.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80; // 80px offset to position below header

            console.log("Current scroll position:", scrollTop);
            console.log("Accordion rect.top:", rect.top);
            console.log("Target position:", targetPosition);

            // Use requestAnimationFrame for smoother scrolling on iOS
            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          } catch (error) {
            console.error("Error scrolling to first accordion:", error);
          }
        } else {
          console.log("No first accordion found, trying fallback");
          // Fallback: try to scroll to the transaction topic container
          const transactionContainer = document.querySelector(".max-w-5xl");
          if (transactionContainer) {
            console.log("Using fallback container");
            const rect = transactionContainer.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80;

            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          }
        }
      };

      // First attempt after a longer delay for iOS
      setTimeout(scrollToFirstAccordion, 100);

      // Second attempt after a longer delay for slower devices
      setTimeout(scrollToFirstAccordion, 300);

      // Third attempt after an even longer delay for very slow devices
      setTimeout(scrollToFirstAccordion, 500);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="body pt-10">
        <strong className="text-red-500 pl-5">
          ***This Section Is Under Development***
        </strong>
        <div className="max-w-5xl w-full flex justify-left mt-5">
          <div className="mt-2 mb-1 max-w-5xl w-full">
            <Accordion
              expanded={expandedAccordion === "panel1"}
              onChange={handleAccordionChange("panel1")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Deposit Instructions
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Please complete the form, as linked below, for all deals so
                  that you are sending the most up to date deposit delivery
                  instructions to the other agent. For any deposit issues please
                  connect with the Deposits Team:{" "}
                  <a href="mailto:abdeposits@exprealty.net">
                    abdeposits@exprealty.net
                  </a>{" "}
                  or 1-833-497-4422.
                  <br />
                  <br />
                  <a
                    href="https://exprealty.formstack.com/forms/alberta_deposits"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Deposit Instructions Form
                  </a>
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel2"}
              onChange={handleAccordionChange("panel2")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Processing Time Sensitive Documents (Cancellations/Deal
                  Collapsed)
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <div>
                  <h2>Listing Terminations/Suspensions </h2>
                  <ol>
                    <li>
                      Once Seller(s) have signed, upload the document in your
                      preferred signing platform and send the form to brokers
                      for signature via{" "}
                      <a href="mailto:ab.broker@exprealty.net">
                        ab.broker@exprealty.net
                      </a>{" "}
                      (Signer's name should be set to "Managing Broker")
                    </li>
                    <li>
                      Once the broker has signed, it will be added to the
                      SkySlope file and the team will terminate the listing from
                      MLS.
                    </li>
                  </ol>
                  <br />

                  <p>
                    To maximize showings/open house visitors on weekends, any
                    "cancel & relists" should ideally be submitted by Wednesdays
                    to allow a day or two for the updates to populate to the
                    various public websites.
                  </p>
                  <p className="pt-5">
                    All documents are processed by admin during regular office
                    hours: Monday to Friday: 9am - 5pm
                  </p>
                </div>
                <br />
                <div>
                  <h2>Deal Collapsed Due to Conditions Not Waived/Satisfied</h2>

                  <ol>
                    <li>
                      Upload Non-Waiver/Non-Satisfaction of Conditions to
                      SkySlope.
                    </li>
                    <li>
                      If deposit made: Complete the necessary FINTRAC documents
                      based on client type.
                    </li>
                    <li>
                      If eXp is holding the deposit, collect a void cheque or
                      bank deposit form from the Buyer's agent so that funds can
                      be returned without delay.
                    </li>
                    <li>
                      Please send a courtesy email to{" "}
                      <a href="mailto:abtransactions@exprealty.net">
                        abtransactions@exprealty.net
                      </a>{" "}
                      to let them know of the collapsed deal - this way we can
                      ensure a speedy process when returning funds in trust.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel3"}
              onChange={handleAccordionChange("panel3")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel3-content"
                id="panel3-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Referral Agreements
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  <a
                    href="https://drive.google.com/drive/folders/1i_gmDWWPJHZx8vbKUAnY-8U5C8l4Sdpi"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here
                  </a>{" "}
                  to access the following Referral Agreements:
                  <br />
                  <br />
                  <ol>
                    <li>Referral Agreement - eXp to non-eXp Agent</li>
                    <li>Referral Agreement - eXp to eXp Agent</li>
                    <li>Lead Referral - From Unlicensed Person</li>
                  </ol>
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel4"}
              onChange={handleAccordionChange("panel4")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel4-content"
                id="panel4-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  eXp SkySlope - Submitting your Documents to the Brokerage
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Deals should be submitted to the Brokerage via SkySlope within
                  48 hours of having an accepted agreement. If your board
                  provides access to SkySlope, as part of your board fees, this
                  is a different SkySlope than eXp's. Login to{" "}
                  <a
                    href="https://app.skyslope.com/LoginIntegrated.aspx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SkySlope
                  </a>{" "}
                  using your @exprealty.com email address.
                  <br />
                  <br />
                  Here are some training videos (2-3 mins) on how to create your
                  listing & transaction files:
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366460-create-a-transaction-canada-"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Create A Buyer/Tenant Transaction (3 mins)
                  </a>
                  <br /> <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366461-create-a-listing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Create A Listing Transaction (2.5 mins)
                  </a>
                  <br />
                  *Some features like transferring over docs automatically may
                  not be available.
                  <br /> <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366436-convert-a-listing-to-a-transaction"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Convert a Listing to a Transaction: Accepted Offer on Your
                    Listing (3 min article)
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366393-using-split-assign"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Split & Assign Documents to the Checklist (2 mins)
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366392-attaching-a-document-to-the-checklist"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Attaching a Document to the Checklist (1 min)
                  </a>
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel5"}
              onChange={handleAccordionChange("panel5")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel5-content"
                id="panel5-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  FINTRAC Documents & Procedures
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <div>
                  <ol>
                    <li>
                      Please complete all required FINTRAC documents for your
                      transaction in the Fintracker app.
                    </li>

                    <li>
                      Once you have completed your FINTRAC document in
                      Fintracker, copy & paste the FIN# in the comment box of
                      your related SkySlope checklist item. Do not upload PDF
                      files to SkySlope.
                    </li>
                    <li>
                      Collapsed deals, where deposit was made, will need
                      FINTRACs completed before funds can be released.
                    </li>
                  </ol>
                  <br />
                  <h2>Fintracker (PC/Mobile)</h2>

                  <ol>
                    <li>
                      All FINTRAC documents are to be completed in the
                      Fintracker app (PC/Mobile).
                    </li>
                    <li>
                      {" "}
                      Create an account at{" "}
                      <a
                        href="https://www.fintracker.ca"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Fintracker.ca
                      </a>{" "}
                      using your @exprealty.com email address.
                    </li>
                    <li>
                      Visit{" "}
                      <a
                        href="https://www.fintracker.ca/tutorials.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        fintracker.ca/tutorials
                      </a>{" "}
                      for tutorials on how to use Fintracker.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
